import http from '@/shared/http';

class ValidateResponseService {
  getValidateResponseFlag() {
    return http.get('/validate');
  }
}

export default new ValidateResponseService();
